import { useContext } from 'react';

import { SessaoContexto, type Sessao } from '@/features/autenticacao/SessaoContexto';

/**
 * Le a sessao ativa.
 *
 * Estoura quando usado fora do provedor, em vez de devolver um objeto vazio. Um
 * valor neutro transformaria erro de montagem em "usuario nao autenticado", e a
 * aplicacao mandaria todo mundo para o login sem explicar por que.
 */
export function useSessao(): Sessao {
  const sessao = useContext(SessaoContexto);

  if (sessao === null) {
    throw new Error('useSessao exige ProvedorDeSessao acima na arvore.');
  }

  return sessao;
}
